import React, { useState, useEffect, useRef } from "react";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { Paper } from "@material-ui/core";
import { DatePicker, Space } from "antd";
import Pagination from "@material-ui/lab/Pagination";
import usePagination from "../../../components/usePagination/usePagination";
import MySelect from "../CustomChallan/MySelect";
import { components } from "react-select";
import makeAnimated from "react-select/animated";
import { IoMdCloseCircle } from "react-icons/io";

function GenerateFee() {
  let today = new Date();
  today.setDate(today.getDate() + 2);
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();
  let currentDate = yyyy + "-" + mm + "-" + dd;

  const [feeloading, setfeeloading] = useState(false);
  const [feemodal, setfeemodal] = useState(false);
  const [feetypes, setfeetypes] = useState([]);
  const [due_date, setdue_date] = useState(currentDate);
  const [issue_date, setissue_date] = useState(currentDate);
  const [isallfields, setisallfields] = useState(false);
  const { RangePicker } = DatePicker;
  const [monthlyFeeInputsvalue, setmonthlyFeeInputsvalue] = useState([]);
  const [isMonthlyFee, setisMonthlyFee] = useState(false);
  const [isInstallmentFee, setisInstallmentFee] = useState(false);
  const [installmentFeeValue, setInstallmentFeeValue] = useState([]);

  const [additiionalfeeinputs, setadditiionalfeeinputs] = useState([1]);
  const [addituionalFeeInputsvalue, setaddituionalFeeInputsvalue] = useState(
    []
  );
  const [isAdditionalFee, setisAdditionalFee] = useState(false);

  const [errorcreate, seterrorcreate] = useState("Please Fill All The Fields");
  const [showCampusName, setShowCampusName] = useState({});

  // New Variables
  const [currentSession, setCurrentSession] = useState("");
  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const authtoken = localStorage.getItem("userToken");
  const [allCampusStudent, setAllCampusStudent] = useState([]);
  const [dataloader, setdataloader] = useState(false);
  const [allsessions, setallsessions] = useState([]);
  const [searchtext, setsearchtext] = useState("");
  const alert = useAlert();

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [selectedChallans, setSelectedChallans] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const firstTimeLoad = useRef(false);

  const [fees_type_id, setfees_type_id] = useState([]);
  const [amount, setAmount] = useState([]);
  const [monthDate, setMonthDate] = useState([]);

  const [optionSelected, setoptionSelected] = useState([]);
  const animatedComponents = makeAnimated();

  const [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(allCampusStudent.length / PER_PAGE);
  const _DATA = usePagination(allCampusStudent, PER_PAGE);

  useEffect(() => {
    if (!firstTimeLoad.current) {
      firstTimeLoad.current = true;
      getAllSessions();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedChallans]);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.map((item, index) => {
          if (item.active_academic_year == "1") {
            setCurrentSession(item.id.toString());
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setmaincheckboxChecked(value);
    if (value) {
      setSelectedChallans([]);
    }

    allCampusStudent.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (allCampusStudent.length == selectedChallans.length) {
      setmaincheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setmaincheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (e, index) => {
    allCampusStudent.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedChallan(item);
        } else {
          RemoveSelectedChallan(item);
        }
      }
    });
  };

  const AddSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) => [
      ...prevSelectedChallans,
      item,
    ]);
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) =>
      prevSelectedChallans.filter((std) => std.id !== item.id)
    );
  };

  const getAllStudents = () => {
    setdataloader(true);
    setAllCampusStudent([]);

    if (currentSession == "" || campusId == "") {
      alert.error("Please Select Session / Campus");
      return;
    }

    const data = {
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      section_id: sectionId,
      year_id: currentSession,
    };

    fetch(`${baseUrl}/all_fee_generate_std_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          searchClicked.current = true;
          setAllCampusStudent(data.payload);
          getfeetypes(
            data.payload[0].campus_id,
            data.payload[0].course_id,
            data.payload[0].student_class_id,
            currentSession
          );
          setdataloader(false);
        } else if (!data.metadata.success) {
          alert.error(data.metadata.message);
          setSelectedChallans([]);
          setdataloader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setdataloader(false);
      });
  };

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const searchbyRegId = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please enter Admission Id or Name");
      return;
    } else {
      setdataloader(true);
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };

      fetch(`${baseUrl}/search_by_name_or_adm_id`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.payload.length == 0) {
            alert.error("No Record Found");
            setSelectedChallans([]);
            setdataloader(false);
          }
          if (data.metadata.success) {
            searchClicked.current = true;
            setAllCampusStudent(data.payload);
            getfeetypes(
              data.payload[0].campus_id,
              data.payload[0].course_id,
              data.payload[0].student_class_id,
              currentSession
            );
            setdataloader(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
          }
        })
        .catch((err) => {
          console.log("err is re", err);
        });
    }
  };

  const addAdditionalInputfield = (e) => {
    e.preventDefault();

    let array = additiionalfeeinputs;
    array.push(1);
    setadditiionalfeeinputs([...array]);
  };

  const getfeetypes = (campusId, courseId, classId, currentsession) => {
    let url = "";
    if (classId != "") {
      url = `${baseUrl}/classfeetypes/${campusId}/${courseId}/${classId}/${currentsession}`;
    } else {
      url = `${baseUrl}/campus/campus-fees/${campusId}/${currentsession}`;
    }

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            let filtered_feetypes = [];
            let array = [];

            if (classId != "") {
              data.payload.map((item) => {
                if (!filtered_feetypes.includes(item.name)) {
                  if (item.name == "MONTHLY FEE") {
                  } else {
                    filtered_feetypes.push(item.name);
                    array.push({ name: item.name, id: item.id });
                  }
                }
              });
            } else {
              data.payload.map((item) => {
                if (!filtered_feetypes.includes(item.fee_name)) {
                  if (item.fee_name == "MONTHLY FEE") {
                  } else {
                    filtered_feetypes.push(item.fee_name);
                    array.push({ name: item.fee_name, id: item.fee_type_id });
                  }
                }
              });
            }
            setfeetypes([...array]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cencelModal = () => {
    setisallfields(false);
    setfeeloading(false);
    seterrorcreate("Please Fill All The Fields");
  };

  const generateSectionFee = async () => {
    setfeeloading(true);

    let monthly_fee_status = isMonthlyFee ? 1 : 0;
    let payment_type = isInstallmentFee ? 1 : 0;
    let installment_fee_status = isInstallmentFee ? 1 : 0;
    let additional_fee_status = isAdditionalFee ? 1 : 0;
    let selected_student = selectedChallans.map((item, index) =>
      String(item.id)
    );

    if (!isMonthlyFee && !isInstallmentFee) {
      if (!isAdditionalFee) {
        setisallfields(true);
        seterrorcreate(
          "Please Add Monthly / Installment Fee or Additional Fee"
        );
        setfeeloading(false);
        return;
      }
    }

    if (monthlyFeeInputsvalue.length == 0) {
      if (isMonthlyFee) {
        setisallfields(true);
        seterrorcreate("Please Add Monthly Fee");
        setfeeloading(false);
        return;
      }
    } else if (installmentFeeValue.length == 0) {
      if (isInstallmentFee) {
        setisallfields(true);
        seterrorcreate("Please Select Installment Fee");
        setfeeloading(false);
        return;
      }
    }

    if (isAdditionalFee) {
      if (
        fees_type_id.length != additiionalfeeinputs.length ||
        additiionalfeeinputs.length != amount.length
      ) {
        setisallfields(true);
        seterrorcreate("Please Add Some Additional Fee");
        setfeeloading(false);
        return;
      }
    }

    if (due_date.length == 0 || issue_date.length == 0) {
      setisallfields(true);
      seterrorcreate("Please Give Due And issue Dates");
      setfeeloading(false);
      return;
    }

    setisallfields(false);
    const data = {
      monthly_fee_status,
      payment_type,
      installment_fee_status,
      additional_fee_status,
      student_id: selected_student,
      fee_months: monthlyFeeInputsvalue,
      installments: installmentFeeValue,
      additional_fees: constructAdditionalFeesArray(),
      due_date,
      issue_date,
    };

    await fetch(`${baseUrl}/all_fee_generate_with_std_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setfeeloading(false);
          if (data?.metadata?.success) {
            setfeemodal(false);
            setfeeloading(false);
            setisallfields(false);
            setisMonthlyFee(false);
            alert.success("Fee Generated Successfully");
          } else {
            setfeemodal(false);
            setfeeloading(false);
            alert.show(
              data?.metadata?.message
                ? data?.metadata?.message
                : "Something went wrong"
            );
          }
          cencelModal();
        })
      )
      .catch((err) => {
        setfeemodal(false);
        alert.show(err);
      });
  };

  const handleChanger = (day, date) => {
    let startDate = date[0] + "-01";
    let endDate = date[1] + "-01";
    var start = startDate.split("-");
    var end = endDate.split("-");
    var startYear = parseInt(start[0]);
    var endYear = parseInt(end[0]);
    var dates = [];

    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
      for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        var month = j + 1;
        var displayMonth = month < 10 ? "0" + month : month;
        dates.push([i, displayMonth, "01"].join("-"));
      }
    }
    setmonthlyFeeInputsvalue(dates);
  };

  const additionalfeeChange = (e, index) => {
    let newAmount = [...amount];
    newAmount[index] = e.target.value;
    setAmount(newAmount);
  };

  const constructAdditionalFeesArray = () => {
    return fees_type_id.map((id, index) => ({
      fees_type_id: id,
      amount: amount[index],
      fee_month: monthDate[index] + "-01",
    }));
  };

  const getCurrentMonthYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11, so add 1
    return `${year}-${month}`;
  };

  const handleFeeSwitch = (e, feeType) => {
    if (feeType === "monthly") {
      setisMonthlyFee(e.target.checked);
      if (e.target.checked) {
        setisInstallmentFee(false);
      }
    } else if (feeType === "installment") {
      setisInstallmentFee(e.target.checked);
      if (e.target.checked) {
        setisMonthlyFee(false);
      }
    }
  };

  const Options = [
    { value: "1", label: "1st Installment" },
    { value: "2", label: "2nd Installment" },
    { value: "3", label: "3rd Installment" },
    { value: "4", label: "4th Installment" },
  ];

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  const handleChangeInstallments = (selected) => {
    setoptionSelected([...selected]);
    let valuearray = [];
    selected.map((item, index) => {
      valuearray[index] = item.value;
    });
    setInstallmentFeeValue([...valuearray]);
    if (valuearray.length == 0) {
      return;
    }
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {allCampusStudent.length == 0 ? (
          <button
            onClick={() => alert.show("Please Select Some Students")}
            className="btn btn-success button_blue"
          >
            Add Fee
          </button>
        ) : (
          <button
            onClick={() => setfeemodal(true)}
            className="btn btn-success button_blue"
          >
            Add Fee
          </button>
        )}
        <br />
        <br />

        <div className="form-group row">
          <div className="col-md-3">
            <label>
              <b>
                Select Session <span style={{ color: "red" }}>*</span>
              </b>
            </label>
            <select
              onChange={(e) => setCurrentSession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentSession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onCampusChange(e.target.value)}
              className="form-select"
              style={{ backgroundColor: "white", height: 40 }}
              value={campusId}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>

              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-12">
            <button className="btn btn-primary" onClick={getAllStudents}>
              Show Student
            </button>
          </div>

          <div className="col-md-8">
            <form className="row mt-9" onSubmit={searchbyRegId}>
              <div className="col-md-8">
                <input
                  onChange={(e) => setsearchtext(e.target.value)}
                  className="form-control"
                  placeholder="Enter Name or Admission ID"
                />
              </div>
              <div className="col-md-4">
                <button type="submit" className="btn btn-primary">
                  Search Student
                </button>
              </div>
            </form>
          </div>
        </div>

        <Table responsive>
          <thead>
            <tr className="text-center">
              <th className="text-start">Student Name</th>
              <th>Monthly Fee</th>
              <th>Addmission ID</th>
              <th>Student Class</th>
              <th>Class Section</th>
              <th className="text-start">
                <input
                  onClick={(e) => {
                    handleMainCheckboxClick();
                  }}
                  checked={mainCheckBoxChecked}
                  placeholder="Checkbox"
                  type="checkbox"
                  readOnly
                />
                <span className="mx-2">Check All</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {_DATA.currentData().map((feechallan, index) => (
              <tr key={index} className="text-center">
                <td className="text-start">{feechallan.name}</td>
                {feechallan.liable_fees.length > 0 ? (
                  feechallan.liable_fees.map((fee, index) =>
                    fee.fees_type_id == 4 ? (
                      <td key={index} title={fee.amount}>
                        {fee.amount}
                      </td>
                    ) : null
                  )
                ) : (
                  <td>0</td>
                )}

                <td>{feechallan?.admission_id}</td>
                <td>{feechallan?.student_class?.name}</td>
                <td>{feechallan?.global_section?.name}</td>
                <td className="text-start">
                  <input
                    type="checkbox"
                    value={feechallan.id}
                    key={feechallan.id}
                    onClick={(e) => {
                      handleChallansCheckBoxClick(e, feechallan.id);
                    }}
                    checked={feechallan.checked ?? false}
                    readOnly
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Pagination
          color="primary"
          count={count}
          size="large"
          page={page}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />

        <div className="row justify-content-center">
          {dataloader && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </div>

        {/* Fee Generate Modal */}
        <Modal size="lg" show={feemodal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Generate Fee - {showCampusName?.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className="form-card">
              <div className="row justify-content-between text-left">
                <div className="form-group col-sm-12 flex-column d-flex">
                  <label className="form-control-label text-center font-size-h5">
                    <b>Payment Type</b>
                  </label>

                  <div className="mt-4">
                    <div className="form-group flex-column d-flex">
                      <div className="flex-row d-flex">
                        <div className="switch">
                          <label className="switchcheckboxlabel flex-row d-flex">
                            <input
                              onChange={(e) => handleFeeSwitch(e, "monthly")}
                              checked={isMonthlyFee}
                              type="checkbox"
                            />
                            <span className="lever"></span>
                            <h3 className="switchcheckboxtext">Monthly Fee</h3>
                          </label>
                        </div>

                        <div className="switch mx-8">
                          <label className="switchcheckboxlabel flex-row d-flex">
                            <input
                              onChange={(e) =>
                                handleFeeSwitch(e, "installment")
                              }
                              checked={isInstallmentFee}
                              type="checkbox"
                            />
                            <span className="lever"></span>
                            <h3 className="switchcheckboxtext">
                              Installment Fee
                            </h3>
                          </label>
                        </div>
                      </div>

                      <div className="flex-column d-flex">
                        {isMonthlyFee && (
                          <div>
                            <div className="row mt-5">
                              <div className="col-md-8">
                                <RangePicker
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                  style={{ height: "40px" }}
                                  picker="month"
                                  onChange={handleChanger}
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {isInstallmentFee && (
                          <div>
                            <div className="row mt-5 col-md-5">
                              <MySelect
                                options={Options}
                                isMulti
                                name="selectedOptions"
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                components={{
                                  Option,
                                  MultiValue,
                                  animatedComponents,
                                }}
                                onChange={handleChangeInstallments}
                                allowSelectAll={true}
                                value={optionSelected}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div>
                      <div>
                        <div className="switch">
                          <label className="switchcheckboxlabel flex-row d-flex">
                            <input
                              onChange={() => {
                                setisAdditionalFee(!isAdditionalFee);
                                setaddituionalFeeInputsvalue([]);
                                setadditiionalfeeinputs([1]);
                                setAmount([]);
                              }}
                              type="checkbox"
                              checked={isAdditionalFee}
                            />
                            <span className="lever"></span>
                            <h3 className="switchcheckboxtext">
                              Additional Fee
                            </h3>
                          </label>
                        </div>

                        {/* {isAdditionalFee ? (
                          <div>
                            <div className="form-group column">
                              {additiionalfeeinputs.map((item, index) => (
                                <div
                                  key={index}
                                  className="col-lg-12 col-sm-12s flex-column d-flex"
                                >
                                  <div>
                                    <label>
                                      Add Additional fee{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <div
                                      style={{
                                        justifyContent: "space-between",
                                      }}
                                      className="flex-row  d-flex  col-lg-12 col-sm-12s"
                                    >
                                      <select
                                        defaultValue={fees_type_id[index]}
                                        value={fees_type_id[index]}
                                        onChange={(e) => {
                                          let updatingarray = [...fees_type_id];
                                          updatingarray[index] = e.target.value;
                                          amount[index] = "";
                                          monthDate[
                                            index
                                          ] = getCurrentMonthYear();
                                          setfees_type_id(updatingarray);
                                        }}
                                        className="form-select"
                                        aria-label="Default select example"
                                      >
                                        <option disabled>
                                          Select Fee Type
                                        </option>
                                        {feetypes.map((fee, index) => (
                                          <option key={index} value={fee.id}>
                                            {fee.name}
                                          </option>
                                        ))}
                                      </select>

                                      <input
                                        className="form-control mx-2"
                                        type="number"
                                        onChange={(e) => {
                                          additionalfeeChange(e, index);
                                        }}
                                        defaultValue={amount[index]}
                                        value={amount[index]}
                                        placeholder="Enter Custom Amount"
                                      />

                                      <input
                                        defaultValue={getCurrentMonthYear()}
                                        value={monthDate[index]}
                                        className="form-control"
                                        onChange={(e) => {
                                          let updatingarray = [...monthDate];
                                          updatingarray[index] = e.target.value;
                                          setMonthDate(updatingarray);
                                        }}
                                        type="month"
                                      />

                                      <button
                                        style={{
                                          marginLeft: "10px",
                                          width: "90px",
                                        }}
                                        id={index}
                                        className="btn btn-danger  "
                                        onClick={(e) => {
                                          e.preventDefault();

                                          setadditiionalfeeinputs(
                                            additiionalfeeinputs.filter(
                                              (item, i) => i !== index
                                            )
                                          );
                                          setfees_type_id(
                                            fees_type_id.filter(
                                              (item, i) => i !== index
                                            )
                                          );
                                          setAmount(
                                            amount.filter(
                                              (item, i) => i !== index
                                            )
                                          );
                                        }}
                                      >
                                        Remove
                                      </button>
                                    </div>
                                    <br />
                                  </div>
                                </div>
                              ))}

                              <br />
                              <div className="col-lg-3 col-sm-12">
                                <button
                                  id="add_additional_Fee_button"
                                  onClick={(e) => {
                                    addAdditionalInputfield(e);
                                  }}
                                  className="btn btn-success button_blue"
                                >
                                  Add Fields
                                </button>
                              </div>
                            </div>
                            <div></div>
                          </div>
                        ) : null} */}
                        {isAdditionalFee ? (
                          <div>
                            <div className="form-group column">
                              {additiionalfeeinputs.map((item, index) => (
                                <div className="col-lg-12 col-sm-12 mb-4">
                                  <div className="row">
                                    <div className="col-md-4">
                                      <label class="form-control-label">
                                        <b>Add Additional Fee</b>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <select
                                        defaultValue={fees_type_id[index]}
                                        value={fees_type_id[index]}
                                        onChange={(e) => {
                                          let updatingarray = [...fees_type_id];
                                          updatingarray[index] = e.target.value;
                                          amount[index] = "";
                                          monthDate[
                                            index
                                          ] = getCurrentMonthYear();
                                          setfees_type_id(updatingarray);
                                        }}
                                        className="form-select h-40px"
                                        aria-label="Default select example"
                                      >
                                        <option selected disabled>
                                          Select Fee Type
                                        </option>
                                        {feetypes.map((fee) => (
                                          <option key={fee.id} value={fee.id}>
                                            {fee.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="col-md-3">
                                      <label class="form-control-label">
                                        <b>(Concession ignored)</b>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        className="form-control"
                                        type="number"
                                        onChange={(e) => {
                                          additionalfeeChange(e, index);
                                        }}
                                        defaultValue={amount[index]}
                                        value={amount[index]}
                                        placeholder="Enter Custom Amount"
                                      />
                                    </div>

                                    <div className="col-md-4">
                                      <label class="form-control-label">
                                        <b>Fee Month</b>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        defaultValue={getCurrentMonthYear()}
                                        value={monthDate[index]}
                                        className="form-control"
                                        onChange={(e) => {
                                          let updatingarray = [...monthDate];
                                          updatingarray[index] = e.target.value;
                                          setMonthDate(updatingarray);
                                        }}
                                        type="month"
                                      />
                                    </div>

                                    <div className="col-md-1 mt-10">
                                      <span
                                        className="svg-icon svg-icon-xl cursor-pointer"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          setadditiionalfeeinputs(
                                            additiionalfeeinputs.filter(
                                              (item, i) => i !== index
                                            )
                                          );
                                          setfees_type_id(
                                            fees_type_id.filter(
                                              (item, i) => i !== index
                                            )
                                          );
                                          setAmount(
                                            amount.filter(
                                              (item, i) => i !== index
                                            )
                                          );
                                        }}
                                      >
                                        <IoMdCloseCircle
                                          color="#F64E60"
                                          height="25px"
                                          width="25px"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}

                              <div className="col-lg-3 col-sm-12">
                                <button
                                  id="add_additional_Fee_button"
                                  onClick={(e) => {
                                    addAdditionalInputfield(e);
                                  }}
                                  className="btn btn-success button_blue"
                                >
                                  Add Fields
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row mt-4">
                      <div className="col-md-4 mt-5">
                        <label className="form-control-label">
                          <b>
                            Due Date <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          format="DD/MM/YYYY"
                          max="9999-12-30"
                          onChange={(e) => setdue_date(e.target.value)}
                          type="date"
                          value={due_date}
                          className="form-control  mb-2"
                        />
                      </div>

                      <div className="col-md-4 mt-5">
                        <label className="form-control-label">
                          <b>
                            Issue Date <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          format="DD/MM/YYYY"
                          max="9999-12-30"
                          value={issue_date}
                          onChange={(e) => setissue_date(e.target.value)}
                          type="date"
                          className="form-control  mb-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{errorcreate}</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>
          {feeloading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                padding: "15px",
              }}
            >
              {" "}
              <span className="spinner-border"></span>{" "}
            </div>
          ) : (
            <Modal.Footer>
              <button
                onClick={generateSectionFee}
                className="btn btn-success button_blue"
              >
                Generate
              </button>

              <button
                onClick={() => {
                  cencelModal();
                  setfeemodal(false);
                }}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default GenerateFee;
